export const FILE_MAX_CHUNK_SIZE = 1024 * 1024 * 5 // 5Mb
